import { render, staticRenderFns } from "./_EditBookingRequest.vue?vue&type=template&id=2983925a&"
import script from "./_EditBookingRequest.vue?vue&type=script&lang=ts&"
export * from "./_EditBookingRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports